import { Box, Grid, Grid2, Paper, Typography, useMediaQuery, useTheme } from "@mui/material"
import { Background } from "./styles"
import { Button, Input, Loader } from "../../../components"
import { useAuthContext, useIP, useMilespayAPI, useToggle } from "../../../hooks"
import { useFormik } from "formik"
import { CheckoutSchema, LoginSchema } from "@milespay.co/validations"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import Cards, { Focused } from 'react-credit-cards-2'
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import { useEffect, useRef, useState } from "react"
import { formatCreditCard, formatCVV, formatExpiry, formatMoney } from "@milespay.co/utils"
import { enqueueSnackbar } from "notistack"
import currency from 'currency.js'
import { COMPANY_ORDER_STATUS } from "@milespay.co/db"
import { HttpStatusCode } from "axios"

export const CieloCheckout = () => {
    const params = useParams()
    const orderId = params['company_order_id']
    
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    console.log('isMobile', isMobile)
    const {ip} = useIP()
    const [focusedField, setFocusedField] = useState<Focused>('name')
    const [companyOrder] = useMilespayAPI(`/company-order/${orderId}`)
    const loadStarted = useRef(false)
    const cieloPayload = useRef({})
    const [loaded, loadedControls] = useToggle(false)
    const [isPaying, isPayingControls] = useToggle(false)
    const [isSuccess, isSuccessControls] = useToggle(false)
    const [paidCompanyOrder, payCompanyOrder] = useMilespayAPI({
        url: `/company-order/${orderId}/pay`,
        method: 'POST'
    }, {
        manual: true
    })

  const formik = useFormik({
    initialValues: {
        card_number: '',
        cvv: '',
        expiry: '',
        name: '',
        installments: '' as unknown as number
    },
    validationSchema: CheckoutSchema,
    validateOnMount: false,
    onSubmit: async (values) => {
        const { status } = await payCompanyOrder({
            data: {
                ...values,
                cielo: cieloPayload.current
            }
        })

        if (status === 200) {
            enqueueSnackbar('Pedido pago com sucesso!', {variant: 'success'})
            isPayingControls.setFalse()
        }
    }
  })

  useEffect(() => {
    if (companyOrder?.data?.cielo && !loadStarted.current && companyOrder?.data.order.status === COMPANY_ORDER_STATUS.PENDING) {
        loadStarted.current = true
    // @ts-expect-error
    window.bpmpi_config = function () {
      return {
        // @ts-expect-error
        onReady: function (e) {
            loadedControls.setTrue()
        },
        // @ts-expect-error
        onSuccess: function (e) {
            cieloPayload.current = e
            formik.submitForm()
          console.log("✅ Success", e);
        },
        // @ts-expect-error
        onFailure: function (e) {
            isPayingControls.setFalse()
            enqueueSnackbar({ variant: 'error', message: `Houve uma falha. Por favor, atualize a página e tente novamente mais tarde. (${e.message})` })
          console.log("❌ Failure", e);
        },
        // @ts-expect-error
        onUnenrolled: function (e) {
            isPayingControls.setFalse()
            enqueueSnackbar({ variant: 'error', message: 'Este cartão não suporta pagamentos autenticados. Por favor, tente novamente com outro cartão.' })
        },
        onDisabled: function () {
          console.log("🔕 Disabled");
        },
        // @ts-expect-error
        onError: function (e) {
            isPayingControls.setFalse()
          enqueueSnackbar({ variant: 'error', message: 'Houve um erro no pagamento. Por favor, atualize a página e tente novamente mais tarde.' })
          console.error("⚠️ Error", e);
        },
        // @ts-expect-error
        onUnsupportedBrand: function (e) {
          console.warn("⚠️ Unsupported Brand", e);
        },
        Environment: "PRD",
        Debug: false,
      };
    };

    const script = document.createElement("script");
    script.src = "https://mpi.braspag.com.br/Scripts/BP.Mpi.3ds20.min.js";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };}
  }, [companyOrder]);

    const installmentsOptions = Array(companyOrder.data?.order?.installments || 1).fill(0).map((_, index) => {
        return {
            label: index === 0 ? 'À vista' : `${index +1}`,
            value: `${index+1}`
        }
    })

    if (companyOrder.loading || paidCompanyOrder.loading) {
        return (
            <Background>
                <Loader />
            </Background>
        )
    }

    if (companyOrder.data.order.status !== COMPANY_ORDER_STATUS.PENDING) {
        return (
            <Background>
                <Paper style={{width: isMobile ? '95vw' : '25vw'}}>
                <Box> 
                    <Grid2 container p={2} spacing={1}>
                        <Grid2>
                            <img src="/assets/logo.png" alt="Milespay Logo" width={"100%"} />
                        </Grid2>
                        <Grid2 size={{xs: 12}} mt={2}>
                            <Typography variant="h6" textAlign={"center"}>
                                {companyOrder.data.order.status === COMPANY_ORDER_STATUS.PAID ? 'Este pedido já foi pago!' : 'Este pedido foi cancelado!'}
                            </Typography>
                        </Grid2>
                        <Grid2 size={{xs: 12}} textAlign={"center"}>
                            <Typography variant="caption">
                                ID: {orderId}
                            </Typography>
                        </Grid2>
                    </Grid2>
                </Box>  
                </Paper>
            </Background>
        )
    }

    if (paidCompanyOrder.data && paidCompanyOrder.response?.status === HttpStatusCode.Ok) {
        return (
            <Background>
                <Paper style={{width: isMobile ? '95vw' : '25vw'}}>
                <Box> 
                    <Grid2 container p={2} spacing={1}>
                        <Grid2>
                            <img src="/assets/logo.png" alt="Milespay Logo" width={"100%"} />
                        </Grid2>
                        <Grid2 size={{xs: 12}} mt={2}>
                            <Typography variant="h6" textAlign={"center"}>
                                Pedido pago com sucesso!
                            </Typography>
                        </Grid2>
                        <Grid2 size={{xs: 12}} textAlign={"center"}>
                            <Typography variant="caption">
                                ID: {orderId}
                            </Typography>
                        </Grid2>
                    </Grid2>
                </Box>  
                </Paper>
            </Background>
        )
    }

    return (
        <Background style={{flexDirection: 'column', gap: 15}}>
                <Paper style={{width: isMobile ? '95vw' : '25vw'}}>
                <Grid2 container p={2}>
                    <Grid2 size={{xs: 4}}>
                        <Typography variant="h6">
                            ID:
                        </Typography>
                    </Grid2>
                    <Grid2 size={{xs: 8}} display="flex" justifyContent="end" alignItems="center">
                        <Typography variant="body1" style={{whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden'}}>
                        {orderId}
                        </Typography>
                    </Grid2>
                    <Grid2 size={{xs: 4}}>
                        <Typography variant="h6">
                            Valor:
                        </Typography>
                    </Grid2>
                    <Grid2 size={{xs: 8}} display="flex" justifyContent="end" alignItems="center">
                        <Typography variant="body1">
                        {formatMoney(companyOrder?.data?.order.price)}
                        </Typography>
                    </Grid2>
                    <Grid2 size={{xs: 4}}>
                        <Typography variant="h6">
                            Em  até:
                        </Typography>
                    </Grid2>
                    <Grid2 size={{xs: 8}} display="flex" justifyContent="end" alignItems="center">
                        <Typography variant="body1">
                        {`${companyOrder.data.order.installments}x`}
                        </Typography>
                    </Grid2>
                </Grid2>
            </Paper>
            <Paper style={{width: isMobile ? '95vw' : '25vw'}}>
                <Box> 
                    <form onSubmit={formik.handleSubmit}>
                        <input type="hidden" className="bpmpi_accesstoken" value={companyOrder?.data?.cielo?.token} />
                        <input type="hidden" className="bpmpi_auth" value="true" />
                        <input type="hidden" className="bpmpi_auth_notifyonly" value="false" />
                        <input type="hidden" className="bpmpi_auth_suppresschallenge" value="false" />
                        <input type="hidden" className="bpmpi_ordernumber" value={orderId} />
                        <input type="hidden" className="bpmpi_currency" value="BRL" />
                        <input type="hidden" className="bpmpi_totalamount" value={currency(companyOrder?.data?.order.price || 0).multiply(100).value} />
                        <input type="hidden" className="bpmpi_installments" value={formik.values.installments} />
                        <input type="hidden" className="bpmpi_paymentmethod" value="Credit" />
                        <input type="hidden" className="bpmpi_cardnumber" value={formik.values.card_number.replace(/\D/ig, '')} />
                        <input type="hidden" className="bpmpi_cardexpirationmonth" value={formik.values.expiry.split('/')[0]} />
                        <input type="hidden" className="bpmpi_cardexpirationyear" value={`20${formik.values.expiry.split('/')[1]}`} />
                        <input type="hidden" className="bpmpi_order_productcode" value="PHY" />
                        <input type="hidden" className="bpmpi_merchant_url" value={'https://dashboard.milespay.com.br'} />
                        <input type="hidden" className="bpmpi_device_ipaddress" value={ip} />
                        <input type="hidden" className="bpmpi_device_1_channel" value="Browser" />
                        <input type="hidden" className="bpmpi_device_1_channel" value="Browser" />
                        <input type="hidden" className="bpmpi_brand_establishment_code" value={companyOrder?.data?.cielo?.mcc} />
                        
                        <Grid2 container p={2} spacing={1}>
                            <Grid2>
                                <img src="/assets/logo.png" alt="Milespay Logo" width={"100%"} />
                            </Grid2>
                            <Grid2 size={{xs: 12}}>
                                <Cards 

                                    cvc={formik.values.cvv}
                                    expiry={formik.values.expiry}
                                    focused={focusedField}
                                    name={formik.values.name}
                                    number={formik.values.card_number}
                                />
                            </Grid2>
                            <Grid2 size={{xs: 12}}>
                                <Input 
                                    label="Nome"
                                    name="name"
                                    value={formik.values.name}
                                    onFocus={() => setFocusedField('name')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    helperText={formik.touched.name && formik.errors.name}
                                    error={formik.touched.name &&!!formik.errors.name} 
                                />
                            </Grid2>
                            <Grid2 size={{xs: 12}}>
                                <Input 
                                    label="Número"
                                    name="card_number"
                                    value={formik.values.card_number}
                                    onFocus={() => setFocusedField('number')}
                                    onChange={({target}) => {
                                        formik.setFieldValue('card_number', formatCreditCard(target.value), true)
                                    }}
                                    onBlur={formik.handleBlur}
                                    helperText={formik.touched.card_number && formik.errors.card_number}
                                    error={formik.touched.card_number &&!!formik.errors.card_number} 
                                />
                            </Grid2>
                            <Grid2 size={{xs: 6}}>
                                <Input 
                                    label="CVV"
                                    name="cvv"
                                    value={formik.values.cvv}
                                    onFocus={() => setFocusedField('cvc')}
                                    onChange={({target}) => {
                                        formik.setFieldValue('cvv', formatCVV(target.value), true)
                                    }}
                                    onBlur={formik.handleBlur}
                                    helperText={formik.touched.cvv && formik.errors.cvv}
                                    error={formik.touched.cvv &&!!formik.errors.cvv} 
                                />
                            </Grid2>
                            <Grid2 size={{xs: 6}}>
                                <Input 
                                    label="Vencimento"
                                    name="expiry"
                                    value={formik.values.expiry}
                                    onFocus={() => setFocusedField('expiry')}
                                    onChange={({target}) => {
                                        formik.setFieldValue('expiry', formatExpiry(target.value), true)
                                    }}
                                    onBlur={formik.handleBlur}
                                    helperText={formik.touched.expiry && formik.errors.expiry}
                                    error={formik.touched.expiry &&!!formik.errors.expiry} 
                                />
                            </Grid2>
                            <Grid2 size={{xs: 12}}>
                                <Input 
                                    select
                                    label="Parcelas"
                                    name="installments"
                                    options={installmentsOptions}
                                    value={formik.values.installments}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    helperText={formik.touched.installments && formik.errors.installments}
                                    error={formik.touched.installments &&!!formik.errors.installments} 
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12 }} mt={1} textAlign={"center"}>
                                <Button disabled={!loaded || !formik.isValid || isPaying} loading={!loaded || isPaying} onClick={async () => {
                                    const valid = await formik.validateForm()
                                    await formik.setTouched({card_number: true, cvv: true, expiry: true, name: true, installments: true})

                                    if (!Object.keys(valid).length) {
                                        isPayingControls.setTrue()

                                        // @ts-expect-error
                                        window.bpmpi_authenticate()
                                    }
                                }}>
                                    Pagar
                                </Button>
                            </Grid2>
                        </Grid2>
                    </form>
                </Box>  
            </Paper>
        </Background>
    )
}